export interface cv_ShipmentContainerCondition {
    C_ShipmentContainerCondition_key: number;
    C_VocabularySource_key: number | null;
    C_Workgroup_key: number;
    CreatedBy: string;
    DateCreated: Date;
    DateModified: Date;
    ElementID: string;
    IsActive: boolean;
    IsDefault: boolean;
    IsDeprecated: boolean;
    ModifiedBy: string;
    ShipmentContainerCondition: string;
    SortOrder: number | null;
    Version: number;
}
